import { Eye, Heart } from 'lucide-react'

import { typographyVariants } from '@ui/web/lib'
import { abbreviateNumber } from '@helper/utils/format'
import cn from '@config/tailwind/cn'

interface ContentStatsProps {
  /** Total likes. Hidden when null/undefined. */
  likes?: number | null
  /** Total views. Hidden when null/undefined. */
  views?: number | null
  className?: string
}

/** Read-only popularity row — view count + like count. Shared across the public showcase pages. */
export function ContentStats({ likes, views, className }: ContentStatsProps) {
  if (likes == null && views == null) return null

  return (
    <div className={cn('srd:flex srd:items-center srd:gap-x-4', className)}>
      {views != null && (
        <div className='srd:flex srd:items-center srd:gap-x-1'>
          <Eye className='srd:size-4 srd:shrink-0' />
          <span className={cn(typographyVariants({ variant: 'body-sm' }))}>{abbreviateNumber(views)}</span>
        </div>
      )}
      {likes != null && (
        <div className='srd:flex srd:items-center srd:gap-x-1'>
          <Heart className='srd:size-4 srd:shrink-0' />
          <span className={cn(typographyVariants({ variant: 'body-sm' }))}>{abbreviateNumber(likes)}</span>
        </div>
      )}
    </div>
  )
}
